export default __webpack_public_path__ + "static/media/Mask Group 33@2x.da57036a.png";